import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Button, CircularProgress, Link, Modal, TextField, Typography } from "@mui/material";

import { sendInvitation } from "@/api/account";
import { paymentPortal } from "@/api/payment";
import { siteName } from "@/constants/config";
import { useGlobalStoreContext } from "@/context/globalStoreContext";
import useEvent from "@/hooks/useEvent";

import Referral from "../Referral";

const Plan = () => {
  const navigator = useNavigate();

  const [loading] = useState(false);
  const [email, setEmail] = useState("");

  const [open, setOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleEmailClose = () => setEmailOpen(false);
  const handleEmailOpen = () => setEmailOpen(true);

  const store = useGlobalStoreContext();

  const handleAction = useEvent(async () => {
    try {
      handleOpen();
      const { url } = await paymentPortal();
      window.location.href = url;
      handleClose();
    } catch (error) {
      handleClose();
    }
  });

  const renderContent = () => {
    if (loading) {
      return (
        <div className="flex justify-center">
          <CircularProgress size={30} />
        </div>
      );
    }

    if (!store.show_upsell) {
      return (
        <div>
          <Typography color="primary" className="!text-[20px] !font-semibold">
            PRO Plan
          </Typography>
          {/* <Typography className="!text-[16px] !font-semibold">$12 / month</Typography> */}
          <Typography variant="body1" className="!mt-[10px] !mb-[10px]">
            Your PRO Plan will renew on {store.expire_date}
          </Typography>
          {/* <Typography variant="body2" className="flex items-center">
            Payment method: MASTERCARD ***5802{" "}
            <Link
              component="button"
              underline="always"
              className="!ml-[4px]"
              onClick={handleAction}
            >
              Update
            </Link>
          </Typography> */}
          <div className="flex items-center space-x-[30px] mt-[10px] text-[13px]">
            <Link component="button" underline="always" onClick={handleAction}>
              Change Plan
            </Link>
            {/* <Link component="button" underline="always" onClick={handleAction}>
              Cancel
            </Link> */}
          </div>
        </div>
      );
    }

    return (
      <>
        <Typography variant="body1" className="!mb-[10px]">
          Thanks for signing up!
        </Typography>
        <Typography className="!mb-[10px]">
          Please select a plan to start searching for great deals.
        </Typography>

        <Button variant="contained" onClick={() => window.open("/pro", "_blank", "noopener,noreferrer")}>
          Subscribe now
        </Button>
      </>
    );
  };

  const renderEmailRefer = () => {
    return (
      <>
        <Typography variant="h4" className="!mt-[45px]">
          Invite Friends
        </Typography>
        <Typography>
          {"Thank you for becoming an " +
            siteName +
            " user! You can type your friend's email address below and we will send them an invitation to join " +
            siteName +
            "."}
        </Typography>
        <TextField
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          id="standard-basic"
          label="email"
          variant="standard"
        />
        <Button
          variant="contained"
          className="!mt-[10px] !ml-[10px]"
          onClick={() => {
            sendInvitation({ email: email });
            handleEmailOpen();
          }}
        >
          Invite
        </Button>
      </>
    );
  };
  const renderReferral = () => {
    if (!store.influencer) {
      return null;
    }

    return (
      <div className="mt-[30px]">
        <Referral />
      </div>
    );
  };

  return (
    <div>
      <Typography variant="h4" className="!mb-[20px]">
        Plan Details
      </Typography>

      {renderContent()}
      {renderEmailRefer()}
      {renderReferral()}

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            boxShadow: 2,
            borderRadius: "12px",
          }}
        >
          <div className="text-center">
            <CircularProgress size={30} />
          </div>
          <Typography color="textPrimary">
            Thank you! 😊 We're redirecting you to payment page... 💳 ✨
          </Typography>
        </Box>
      </Modal>
      <Modal open={emailOpen} onClose={handleEmailClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            p: 4,
            boxShadow: 2,
            borderRadius: "12px",
          }}
        >
          {/* <div className="text-center">
            <CircularProgress size={30} />
          </div> */}
          <Typography color="textPrimary">
            Thank you for introducing us to your friend! 😊
          </Typography>
          <Typography color="textPrimary">
            An invitation email has been sent to your friend. ❤️
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default Plan;
